module.exports = {
  white: '#f5f5f5',
  black: '#141414'
};